import {styled} from '../theme-provider';

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({theme}) => theme.palette.general.lightGrey[60]};
`;
